import { Drawer } from "antd";
import styled from "styled-components";

export const StyledDrawer = styled(Drawer)`
  .ant-drawer-body {
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 0;
  }
`;

export const DrawerHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 20px 24px;
  border-bottom: 1px solid #e7ecef;
`;

export const CloseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border: none;
  border-radius: 50%;
  background: #f1f5f8;
  color: #7a8995;
  cursor: pointer;
`;

export const DrawerTitle = styled.h2`
  margin: 0;
  color: #164a70;
  font-family: "Inter", sans-serif;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.2;
`;

export const DrawerBody = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 24px;
`;

export const FantasyNameTitle = styled.h2`
  margin: 0 0 4px;
  color: #164a70;
  font-family: "Inter", sans-serif;
  font-size: 18px;
  font-weight: 700;
`;

export const ContractSubtitle = styled.h3`
  margin: 0 0 20px;
  color: #6d7c88;
  font-family: "Inter", sans-serif;
  font-size: 15px;
  font-weight: 500;
`;

export const ContractValue = styled.strong`
  color: #164a70;
  font-weight: 600;
`;

export const StatsList = styled.div`
  display: flex;
  min-height: ${({ loading }) => (loading ? "180px" : "auto")};
  align-items: center;
  flex-direction: column;
  justify-content: ${({ loading }) => (loading ? "center" : "flex-start")};
`;

export const StatsRow = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid #e7ecef;
  padding: 9px 0;
  color: ${({ total }) => (total ? "#164a70" : "#465866")};
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-weight: ${({ total }) => (total ? 700 : 500)};
`;

export const StatsLabel = styled.span``;

export const StatsValue = styled.span`
  color: ${({ total }) => (total ? "#164a70" : "#26343d")};
  font-weight: ${({ total }) => (total ? 700 : 600)};
`;

export const DrawerFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  border-top: 1px solid #e7ecef;
`;

export const PaginationGroup = styled.div`
  display: flex;
  border: 1.5px solid #dfdfe0;
  border-radius: 10px;
  overflow: hidden;
`;

export const PaginationButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 34px;
  border: none;
  background: #fff;
  color: #314158;
  cursor: pointer;
  transition: background-color 200ms ease-in-out;

  &:not(:first-child) {
    border-left: 1.5px solid #dfdfe0;
  }

  &:hover:not(:disabled) {
    background: #f1f5f8;
  }

  &:disabled {
    color: #c2c9d1;
    cursor: not-allowed;
  }
`;

export const FooterActions = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const CancelButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 16px;
  border-radius: 8px;
  border: 1.5px solid #dfdfe0;
  background: #fff;
  color: #0f172a;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  height: 34px;
`;

export const StartServiceButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  background: #11a7d9;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  font-family: "Inter", sans-serif;
  transition: all 300ms ease-in-out;
  height: 34px;
  box-shadow: 0px 1px 2px 0px #19191c0a;

  &:hover {
    background: rgb(14, 134, 174);
  }
`;
